// Opens a Google Drive folder this caller was already allowed to list.
// The href is only rendered when it is a Drive folder URL — never a
// client-typed id, and never javascript: or an arbitrary link.
import type { JSX } from 'preact';

export function isDriveFolderUrl(url: string | undefined): url is string {
  return typeof url === 'string' && url.startsWith('https://drive.google.com/drive/folders/');
}

/** Build a Drive folder URL from an id the server already gave us. */
export function driveFolderUrlFromId(id: string | undefined): string | undefined {
  if (!id || typeof id !== 'string' || /[^a-zA-Z0-9_-]/.test(id)) return undefined;
  return `https://drive.google.com/drive/folders/${id}`;
}

export function OpenFolderLink(
  { url, label, text = 'Open folder' }: { url: string | undefined; label: string; text?: string },
): JSX.Element | null {
  if (!isDriveFolderUrl(url)) return null;
  return (
    <a
      class="doc-link"
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid={`open-folder-${label}`}
    >
      {text}
    </a>
  );
}
